/* Shilajit Global — scroll-entrance engine for the sg-* home sections.
 *
 * Contract with sg-home.css: nothing is ever hidden until this file has
 * confirmed IntersectionObserver support AND no reduced-motion preference,
 * at which point it stamps html.sg-io. Only under that class does the
 * stylesheet apply the hidden starting states, so a failure anywhere in
 * here degrades to a fully visible static page.
 *
 * The file is included by several sections and may therefore execute more
 * than once per page; the window.__sgReveal guard makes every run after
 * the first a no-op. */
(function () {
  'use strict';

  if (window.__sgReveal) return;
  window.__sgReveal = true;

  var reduced;
  try {
    reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {
    reduced = false;
  }

  if (reduced || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('sg-io');

  var io = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('is-in');
          io.unobserve(entries[i].target);
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  function scan(root) {
    var els = (root || document).querySelectorAll('.sg-rv, .sg-draw, .sg-grow');
    for (var i = 0; i < els.length; i++) {
      if (!els[i].classList.contains('is-in')) io.observe(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  /* Theme editor: a re-rendered section arrives with fresh, unobserved
   * nodes. Reveal them immediately rather than waiting for a scroll. */
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
